





















































import {
  GeekItem,
  Permission,
} from '@/models';
import { OpportunityItemStatus, OpportunityActions, Opportunity } from '@/models/opportunities';
import { typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'DetailsHeaderActionDispatcher',
  props: {
    opportunity: Object as () => Opportunity,
  },
  computed: {
    isEditActionVisible(): boolean {
      return ((this.opportunity.approvers as GeekItem[]).some(a => a.id === typedStore(this).state.geek.current.id)
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Pending;
    },
    isRejectActionVisible(): boolean {
      return (((this.opportunity.approvers as GeekItem[]).some(a => a.id === typedStore(this).state.geek.current.id)
        && this.opportunity.issuer.id !== typedStore(this).state.geek.current.id)
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Pending;
    },
    isDeleteActionVisible(): boolean {
      return (this.opportunity.issuer.id === typedStore(this).state.geek.current.id
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Pending;
    },
    isCancelActionVisible(): boolean {
      return (this.opportunity.issuer.id === typedStore(this).state.geek.current.id
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Recruiting;
    },
    isCancelOngoingActionVisible(): boolean {
      return (this.opportunity.issuer.id === typedStore(this).state.geek.current.id
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Ongoing;
    },
    isFinalizeActionVisible(): boolean {
      return (this.opportunity.issuer.id === typedStore(this).state.geek.current.id
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Ongoing;
    },
  },
  methods: {
    rejectOpportunity() {
      this.$emit(OpportunityActions.Reject);
    },
    deleteOpportunity() {
      this.$emit(OpportunityActions.Delete);
    },
    cancelOpportunity() {
      this.$emit(OpportunityActions.Cancel);
    },
  },
});
